/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import React from "react";
import { useDispatch } from "react-redux";

import { customUseEffect } from "@common";

import { setShowErrorAlert,setShowErrorAlertMessage } from "@features";

function ErrorNotifier({message, ...props}) {

  const dispatch = useDispatch();
  customUseEffect(() => {
    dispatch(setShowErrorAlert(true));
    dispatch(setShowErrorAlertMessage(message));
  }, [message]);

  return <></>;
}
export default ErrorNotifier;
